// extracted by mini-css-extract-plugin
export default {"localization__placeholder":"Localization_localization__placeholder__-RbsC"};